import type { UiActionParameters } from './ui-action'

import { createWatch } from 'effector'
import { SnapshotMap } from '../../general/snapshot-map'
import { $openFrom } from '../models/routes'

const SNAPSHOTS_TO_KEEP = 0

/**
 * SnapshotMap to store `ui_action` event parameters with their history
 * for "Movie of the Night" feature
 */
export const parameters = new SnapshotMap<UiActionParameters>(
  SNAPSHOTS_TO_KEEP,
  [
    ['featureIdentifier', 'movie_of_the_night'],
    ['actionName', 'tap'], // always 'tap' for all events for Movie of the Night feature
  ]
)

//
// Update parameters
//

function fromOpenFrom(openFrom: string) {
  parameters //
    .update('route', openFrom)
    .commit()
    .notify()
}

//
// Updates listeners
//

// on content open source change
createWatch({
  unit: $openFrom,
  fn: (openFrom) => {
    fromOpenFrom(openFrom)
  },
})
